import httpDao from "../infrastructure/httpDao";
import { AxiosResponse } from "axios";
import type { MemberManagementMode } from "@/lib/memberManagementMode";

export type Facility = {
  id: string;
  name: string;
  postalCode?: string;
  prefecture?: string;
  city?: string;
  address?: string;
  building?: string;
  phoneNumber?: string;
  email?: string;
  equipmentIds?: string[];
  image?: string;
  description?: string;
  industry?: string;
  memberManagementMode?: MemberManagementMode | null;
  effectiveMemberManagementMode?: MemberManagementMode;
};

export const facilityRepository = {
  findAll: async (): Promise<AxiosResponse<Facility[]>> => {
    // 現在のバックエンドAPIがまだ実装されていない可能性があるため
    // 本来は /facilities エンドポイントを叩く
    // とりあえず実装だけしておく（後でバックエンド側に追加が必要）
    const res = await httpDao.get("/facilities");
    return res;
  },

  findById: async (id: string): Promise<AxiosResponse<Facility>> => {
    return await httpDao.get(`/facilities/${id}`);
  },

  findOne: async (id: string): Promise<AxiosResponse<Facility>> => {
    return await httpDao.get(`/facilities/${id}`);
  },

  remove: async (id: string): Promise<AxiosResponse<void>> => {
    return await httpDao.delete(`/facilities/${id}`);
  },
};
